<template>
<div id='addressList'>

	<div v-if='adl_show !== 0' :class="{'adl-mask':true, 'adl-mask-close':adl_show === 2}" @click='vadl_close'></div>
	<div :class="{'adl-model no-copy':true, 'adl-model-show':adl_show === 1}">
		<div class='adl-model-title fontcolor-15-shallow'>您的地址列表</div>
		<div v-for='(item,index) in adl_list' 
			 :key='item.id' 
			 class='adl-model-view' 
			 :data-index='index' 
			 @click='vadl_callback' 
			 >
			 <div class='adl-model-view-name font-16'>{{item.rsrvstr1}}</div>
			 <div class='adl-model-view-phone font-16 color-prompt-deep'>{{item.rsrvstr4}}</div>
			 <div class='adl-model-view-company font-14 color-prompt-deep'>{{item.rsrvstr2}}</div>
			 <div class='adl-model-view-address font-14 color-prompt-deep'>{{item.province + item.city + item.area + item.address}}</div>
			 <div class='adl-model-view-prompt font-20 fontweight-bo'>切换</div>
		</div>
    <div class='adl-model-viewAdd' @click='vadl_callback_create'>
			 <img class='adl-model-viewAdd-icon' src='@/assets/icon/opera_xinzeng.png' />
       <div class='font-20 color-prompt'>新增地址</div>
		</div>
	</div>

</div>
</template>
<script>
export default {
	name: 'addressList',
	props: {},
	data() {
		return {
			adl_show: 0,
      adl_list: [],
      temp_index: -1,
		}
	},
	methods: {
		// show方法
		vadl_Change(adl_list, index) {
      this.adl_list = adl_list;
      this.temp_index = index;
			this.adl_show = 1;
		},
		// close方法
		vadl_close() {
			this.adl_show = 2;
			setTimeout(() => {
				this.adl_show = 0;
			}, 200)
		},
		// 选择
		vadl_callback(event) {
			const index = event.currentTarget.dataset.index;
			this.$parent.vadl_callback(index, this.temp_index);
			this.vadl_close();
    },
    // 新增地址
    vadl_callback_create() {
      this.$parent.vadl_callback_create(this.temp_index);
      this.vadl_close();
    }
	}
}
</script>
<style scoped>
#addressList {
}
.adl-mask {
	background:rgba(0, 0, 0, 0);
	width:100%; height:100vh;
	position:fixed; top:0; left:0;
  animation: adlMaskShow 0.2s linear 0s forwards;
  z-index:210;
}
@keyframes adlMaskShow
{
	from {background:rgba(0, 0, 0, 0);}
	to {background:rgba(0, 0, 0, 0.5);}
}
.adl-mask-close {
	animation: adlMaskClose 0.2s linear 0s forwards;
}
@keyframes adlMaskClose
{
	from {background:rgba(0, 0, 0, 0.5);}
	to {background:rgba(0, 0, 0, 0);}
}
.adl-model {
	background:#ffffff;
	width:100%;
	display:flex; flex-wrap:wrap;
	padding:26px 0 10px 10px;
	border-bottom-left-radius:10px; border-bottom-right-radius:10px;
	position:fixed; top:0; left:0;
	transform: translateY(-100%);
  transition: all 0.3s ease-in-out 0s;
  z-index:210;
}
.adl-model-show {
	transform: translateY(0);
}
.adl-model-title {
	width:90%; margin-left:16px;
}
.adl-model-view {
	width:300px; margin:10px 16px;
	display:inline-flex; flex-wrap:wrap;
	padding:6px 14px;
	border-radius:6px;
	border:2px solid #ccc;
	cursor:pointer;
	position:relative;
	transition: all 0.2s ease-in-out 0s;
}
.adl-model-view-name {
	width:100px; margin:4px 0;
}
.adl-model-view-phone {
	width:140px; margin:6px 0 4px 0;
}
.adl-model-view-company {
	width:100%; margin:2px 0;
}
.adl-model-view-address {
	width:100%; margin:2px 0;
}
.adl-model-view-prompt {
	color:rgba(255, 104, 1, 1);
	text-shadow: -1px -1px 0 #fff,1px 1px 0 rgba(255, 104, 1, .8),1px 1px 0 rgba(255, 104, 1, .6);
	opacity:0;
	position:absolute; top:6px; right:10px;
	transition: all 0.2s ease-in-out 0s;
}
.adl-model-view:hover {
	border-color:rgba(255, 104, 1, 1);
}
.adl-model-view:hover .adl-model-view-prompt {
	opacity:1;
}
.adl-model-viewAdd {
  width:300px; margin:10px 16px;
	display:inline-flex; justify-content:center; align-items:center;
	padding:6px 14px;
	border-radius:6px;
	border:2px solid #ccc;
	cursor:pointer;
	position:relative;
	transition: all 0.2s ease-in-out 0s;
}
.adl-model-viewAdd-icon {
  width:24px; height:24px; margin-right:6px;
}
.adl-model-viewAdd:hover {
  border-color:rgba(255, 104, 1, 1);
}
</style>




// WEBPACK FOOTER //
// src/components/address/addressList.vue